import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShareAccessLevel, SharedUser } from '../canvas.model';
import { CanvasService } from '../canvas.service';
import { cloneDeep } from 'lodash';
import { SnackbarService } from 'src/app/services/common/snackbar.service';
import { CanvasHelperService } from '../canvas-helper.service';

@Component({
  selector: 'app-canvas-session-share-dialog',
  templateUrl: './canvas-session-share-dialog.component.html',
  styleUrl: './canvas-session-share-dialog.component.scss',
})
export class CanvasSessionShareDialogComponent {
  shareAccessLevels = ShareAccessLevel;
  displayedColumns: string[] = ['email', 'role', 'delete'];

  isUpdatingUsers: boolean = false;
  sharedUsersList: SharedUser[] = [];

  loggedUserId: string = '';

  get sharedWith() {
    return this.data?.session?.shared_with ?? [];
  }

  constructor(
    public dialogRef: MatDialogRef<CanvasSessionShareDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly snackbar: SnackbarService,
    private readonly canvasService: CanvasService,
    private readonly helperService: CanvasHelperService
  ) {
    this.sharedUsersList = cloneDeep(this.sharedWith ?? []);
  }

  ngOnInit() {
    this.loggedUserId = this.canvasService.auth.getUserId();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onEvent($event: any) {
    this.sharedUsersList = $event;
  }

  removeUser(user: any) {
    this.helperService
      .showConfirmationShareRemoveDialog()
      .then((result: any) => {
        if (result) {
          this.sharedUsersList = this.sharedUsersList.filter(
            (sharedUser) => sharedUser.user_id !== user.user_id
          );
          if (!user.temporary_user) this.updateUsersList(this.sharedUsersList);
        }
      });
  }

  updateUsersList(sharedUsersList: SharedUser[]) {
    if (this.isUpdatingUsers) {
      return;
    }
    this.isUpdatingUsers = true;
    this.canvasService
      .updateSharedList(sharedUsersList, this.data?.session?._id)
      .subscribe({
        next: (response: any) => {
          if (response?.session_id != null) {
            this.sharedUsersList = response?.shared_with ?? [];
            this.updateSharedUsersList(
              response?.session_id,
              response?.shared_with ?? []
            );
          }
          this.isUpdatingUsers = false;
          this.snackbar.openSuccessBar('Shared list updated successfully');
        },
        error: (error: any) => {
          this.isUpdatingUsers = false;
          this.canvasService.showErrorMessage('Faled to update shared list');
        },
      });
  }

  updateUserPermission(user: SharedUser, permission: ShareAccessLevel): void {
    user.permission = permission;
  }

  updateSharedUsersList(session_id: any, sharedWith: SharedUser[]) {
    let session = this.canvasService.sessions?.find((session: any) => {
      return session._id === session_id;
    });
    if (session) {
      session.shared_with = sharedWith;
    }
  }

  shareUsers() {
    if (this.sharedUsersList.length > 0) {
      this.updateUsersList([
        ...cloneDeep(
          this.sharedUsersList.map((user) => {
            return {
              user_id: user.user_id,
              user_email: user.user_email,
              permission: user.permission,
              shared_by: user.shared_by,
            };
          })
        ),
      ]);
    }
  }
}
